import { createFileRoute } from '@tanstack/react-router'

import StateFilingsCancelPage from '@/features/state-filings/pages/cancel'

export const Route = createFileRoute('/_shell/state-filings/cancel')({ component: StateFilingsCancelPage })
